import { CALL_API } from './api'
import moment from 'moment-timezone'
import {
    timeFormat,
    getUserId,
    setRefreshToken,
    getExpiresToken,
    CORE_API_ENDPOINT
} from 'Lib'

export default store => next => action => {
    const entry = action[CALL_API]
    const currentTime = moment().format(timeFormat)

    const expires = getExpiresToken()

    const duration = moment.duration(moment.unix(expires).diff(currentTime))
    const minutes = duration.asMinutes()

    if (typeof entry !== 'object') return next(action) 
        if (minutes < 15 && minutes > 0) {
            fetch(`${CORE_API_ENDPOINT}/user/newtoken`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        'id': getUserId()
                    })
                })
                .then(res => res.json())
                .then(json => setRefreshToken(json))
                .then(() => next(action))
        } 
       else if(minutes <= 0 ){
          if(window.location.pathname !== "/sessionExpire")
          window.location.replace('/sessionExpire')

       }
        else {
            next(action)
        }
    // }
}


// WEBPACK FOOTER //
// ./src/middlewares/checkToken.js